export function formatPrice(value, locale = 'en-US') {
  if (typeof value !== "number") {
    console.warn("formatNumber: Giá trị không phải là số");
    return value;
  }
  return new Intl.NumberFormat('en-US').format(value);
}
